export class BusinessSettingsInput {
    id!: number | null;
    openOnHolidays!: boolean | null;
    onlineBookingType!: string | null;
    autoApproveAppointment!: string | null;
    cardOnBookingType!: string | null;
    preAuthorizationPercentage!: number | null;
    bookingWindow!: number | null;
    bookingIncrement!: number | null;
    allowAdvancedBooking!: boolean | null;
    advancedBookingWindow!: number | null;
    allowBookingOutsideBusinessHours!: boolean | null;
    allowOnlineCancellation!: boolean | null;
    requireCancellationPolicy!: boolean | null;
    cancellationPolicy!: string | null;
    cancellationWindow!: number | null;
    cancellationFee!: number | null;
    allowWaitlist!: boolean | null;
    waitlistWindowDays!: number | null;
    notifyWaitlistAvailableSpot!: boolean | null;
    waitlistAvailableSpotConfirmationWindow!: number | null;
    enableWaitingRoom!: boolean | null;
    healthMode?: boolean | null;
    acceptBookingAtFixedLocation!: boolean | null;
    acceptBookingOutsideLocation!: boolean | null;
}
